export const DEFAULT_ACTION = "app/AllottedCases/DEFAULT_ACTION";
export const CASEUPDATE = "app/AllottedCases/CASEUPDATE";